// Sample data for High Stock Items DataTable
export const sampleTopOnHand = [
  { item_name: "Canned Carrots", current_qty: "507" },
  { item_name: "Frozen Chicken Tenders", current_qty: "409" },
  { item_name: "Frozen Burritos", current_qty: "386" },
  { item_name: "Canned Corn", current_qty: "374" },
  { item_name: "Macaroni Pasta", current_qty: "334" },
  { item_name: "Canned Green Beans", current_qty: "296" },
  { item_name: "Frozen Lasagna", current_qty: "280" },
  { item_name: "All-Purpose Flour", current_qty: "255" },
  { item_name: "White Rice", current_qty: "175" },
  { item_name: "Updated Item Name", current_qty: "101" }
];

// Sample data for Out of Stock Items DataTable
export const sampleTopOutOfStock = [
  { item_name: "Canned Peas", last_transaction: "2025-09-01" },
  { item_name: "Toothpaste", last_transaction: "2025-08-28" }
];

// Sample data for Low Stock Items DataTable
export const sampleLowStock = [
  {
    item_name: "Shampoo",
    current_qty: "5",
    projected_operation_days_left: "2",
    projected_continuous_operation_run_out_date: "2025-09-18"
  },
  {
    item_name: "Soap",
    current_qty: "8",
    projected_operation_days_left: "3",
    projected_continuous_operation_run_out_date: "2025-09-19"
  }
];

// Sample data for Top 10 Distributed Items DataTable
export const sampleTopPopularItems = [
  { item_name: "Canned Carrots", total_sold: "120" },
  { item_name: "Frozen Chicken Tenders", total_sold: "95" },
  { item_name: "Frozen Burritos", total_sold: "110" },
  { item_name: "Canned Corn", total_sold: "80" },
  { item_name: "Macaroni Pasta", total_sold: "75" },
  { item_name: "Canned Green Beans", total_sold: "60" },
  { item_name: "Frozen Lasagna", total_sold: "55" },
  { item_name: "All-Purpose Flour", total_sold: "50" },
  { item_name: "White Rice", total_sold: "45" },
  { item_name: "Updated Item Name", total_sold: "40" }
];

// Sample data for Distribution Trends Line Chart
export const sampleDailyDistributedQuantity = [
  { date: "2025-09-10", total_quantity: 120 },
  { date: "2025-09-11", total_quantity: 95 },
  { date: "2025-09-12", total_quantity: 110 },
  { date: "2025-09-13", total_quantity: 80 },
  { date: "2025-09-14", total_quantity: 75 },
  { date: "2025-09-15", total_quantity: 60 }
];

export const sampleDailyDistributedValue = [
  { distribution_day: "2025-09-10", daily_distributed_value: 350.50 },
  { distribution_day: "2025-09-11", daily_distributed_value: 275.00 },
  { distribution_day: "2025-09-12", daily_distributed_value: 400.75 },
  { distribution_day: "2025-09-13", daily_distributed_value: 200.00 },
  { distribution_day: "2025-09-14", daily_distributed_value: 180.25 },
  { distribution_day: "2025-09-15", daily_distributed_value: 150.00 }
];

// Sample data for Category Distribution Pie Chart
export const sampleCategoryQOH = [
  { category: "Canned Vegetables", quantity: "1177", percentage: "37.76" },
  { category: "Dry Goods", quantity: "865", percentage: "27.75" },
  { category: "Frozen Meals", quantity: "1075", percentage: "34.49" }
];

// Sample heading statistics for line chart legend
export const headingStatistics = [
  { value: 120, label: "Food" },
  { value: 95, label: "Personal Care" },
  { value: 60, label: "Household" }
];

// Sample columns for DataTables
export const columnsTopOnHand = [
  { title: 'Item Name', data: 'item_name' },
  { title: 'QOH', data: 'current_qty' },
];

export const columnsTopOutOfStock = [
  { title: 'Item Name', data: 'item_name', width: '25%' },
  { title: 'Last Transaction', data: 'last_transaction' }
];

export const columnsLowStock = [
  { title: 'Item Name', data: 'item_name' },
  { title: 'QOH', data: 'current_qty' },
  { title: 'Days Left', data: 'projected_operation_days_left' },
  { title: 'Run-Out Date', data: 'projected_continuous_operation_run_out_date' }
];

export const columnsTopPopularItems = [
  { title: 'Item Name', data: 'item_name' },
  { title: 'Units Distributed', data: 'total_sold' },
];